import React from 'react';
import Alert from 'react-bootstrap/Alert';
import Card from 'react-bootstrap/Card';
import Spinner from 'react-bootstrap/Spinner';
import CartDiamondsTable from './CartDiamondsTable';
import { updateSavedCartStatus, deleteSavedCartDiamond } from '../../../Util/SavedCart';

function ShowCart(props) {
  const {savedCartDetails, refreshSavedCartDetails} = props;
  const {loading, errorMessage, savedCart, cartItems} = savedCartDetails;

  if(errorMessage !== null){
    return (
      <Alert variant="danger">
        Loading Error: {errorMessage}
      </Alert>
    );
  }

  if(loading){
    return (
      <div className="text-center m-5 p-5">
        <Spinner animation="border" />
      </div>
    );
  }

  const isEmptyCart =
    savedCart === null ||
    cartItems === null ||
    cartItems.length === 0;

  if(isEmptyCart) {
    return (
      <Card className="m-3"><Card.Body>No items in cart</Card.Body></Card>
    );
  }

  function onDelete(cartDiamond) {
    deleteSavedCartDiamond(savedCart.id, cartDiamond.id)
      .then(refreshSavedCartDetails);
  }

  function emptyCart(finalStatus = 'ordered') {
    updateSavedCartStatus(savedCart.id, finalStatus)
      .then(refreshSavedCartDetails);
  }

  return (
    <div>
      <CartDiamondsTable
        cartDiamonds={cartItems}
        emptyCart={emptyCart}
        onDelete={onDelete}
      />
    </div>
  );
}

export default ShowCart;
